export default __webpack_public_path__ + "static/media/placeholder_dummy2016-immobilien01-mobile-de.b935cb80.png";